// CONTRACT: password-Feld ist BEWUSST ausgeschlossen — Bcrypt-Hashes dürfen nicht ins Browser-Memory.
// mcp_enabled ist erforderlich (persisted state fuer MCP-Admin-Ui-Toggle).
// Kanonische Quelle: apps/frontend/src/Apollo/queries/getAllUser.ts (GQL-Version mit mcp_enabled, ohne password).
const getAllUser = `getAllUser{id, username, email, enabled, mcp_enabled, last_login, roles,}`;

export default getAllUser;
